import React from 'react'
// import useFirestore from '../hooks/useFirestore'
import useRealFirestore from '../hooks/useRealFirestore'

const Output = () => {

    const {docs} = useRealFirestore('images')
    console.log(docs)

    return (
        <div className="gallery">
            {docs && docs.map(doc =>{
                return (<div key={doc.id} style={{display : 'inline'}}>
                    <img style={imageStyles} src={doc.imageUrl} alt={doc.id}/>
                </div>)
            })}
        </div>
    )
}

const imageStyles = {
    height : '100px',
    width : '100px', 
    borderRadius : '10px',
    margin : '10px'
}

export default Output